(function (window, document) {
  'use strict';

  if (window.BeefcakeZestySignup) {
    window.BeefcakeZestySignup.bind(document);
    return;
  }

  var selector = 'form[data-zesty-signup]';
  var forms = new Map();
  // Session memory only: inline and popup forms share an in-flight request.
  var requests = new Map();
  var acceptedMessage = 'Request received. If email confirmation is needed, follow the link in your inbox. Your signup is not a reservation.';
  var uncertainMessage = 'We could not confirm your request. It may have been received. Please wait a few minutes before trying again.';

  function announce(state, phase, message) {
    if (state.destroyed || !state.form.isConnected) return;
    state.form.dataset.signupState = phase;
    state.form.setAttribute('aria-busy', phase === 'loading' ? 'true' : 'false');
    state.status.hidden = false;
    state.status.textContent = message;
    state.button.disabled = !state.ready || phase === 'loading' || phase === 'accepted';
    state.input.disabled = !state.ready;
    state.input.readOnly = phase === 'loading' || phase === 'accepted' || state.originalReadOnly;
    state.button.textContent = phase === 'loading' ? 'Sending…' : phase === 'accepted' ? 'Request received' : state.originalLabel;
    if (phase !== 'loading' && state.form.contains(document.activeElement)) {
      state.status.focus({ preventScroll: true });
    }
  }

  function configuration(form) {
    var config = {
      company: (form.dataset.company || '').trim(),
      list: (form.dataset.listId || '').trim(),
      interest: form.dataset.interest,
      placement: form.dataset.placement,
      campaign: form.dataset.campaign
    };
    // Public six-character IDs only; never send an accidentally pasted private key.
    if (!/^[a-zA-Z0-9]{6}$/.test(config.company) || !/^[a-zA-Z0-9]{6}$/.test(config.list)) return null;
    if (['launch', 'future_drops'].indexOf(config.interest) === -1) return null;
    if (['inline', 'hero_popup'].indexOf(config.placement) === -1) return null;
    if (!/^[a-z0-9_]{1,80}$/.test(config.campaign || '')) return null;
    return config;
  }

  function payload(email, config) {
    var properties = {};
    var propertyPrefix = 'bcj_' + config.campaign + '_' + config.interest;
    properties[propertyPrefix + '_interest'] = true;
    properties[propertyPrefix + '_requested_at'] = new Date().toISOString();
    properties[propertyPrefix + '_placement'] = config.placement;
    if (config.interest === 'future_drops') properties.bcj_future_drop_interest = true;
    // Set only this request's properties. Do not replace other preference arrays,
    // set another interest to false, or change any SMS/tracking consent.
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'bcj:' + config.campaign + ':' + config.interest + ':' + config.placement,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: properties,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: config.list } } }
      }
    };
  }

  function trackAccepted(config) {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (window.navigator.globalPrivacyControl === true || !privacy ||
          typeof privacy.analyticsProcessingAllowed !== 'function' ||
          privacy.analyticsProcessingAllowed() !== true) return;
      var detail = { status: 'accepted', campaign: config.campaign, interest: config.interest, placement: config.placement };
      document.dispatchEvent(new CustomEvent('zesty:signup', { detail: detail }));
      // Use the existing storefront custom-pixel publishing bridge. This is a
      // request metric, never a new or confirmed subscriber conversion.
      var analytics = window.Shopify.analytics;
      if (analytics && typeof analytics.publish === 'function') {
        try {
          Promise.resolve(analytics.publish('bcj_zesty_signup_request', detail)).catch(function () {});
        } catch (error) { /* The accepted request remains successful. */ }
      }
    } catch (error) {
      // Analytics failure must not change a functional signup result.
    }
  }

  function send(email, config) {
    var key = [config.company, config.list, config.campaign, config.interest, email.toLowerCase()].join(':');
    if (requests.has(key)) return requests.get(key);
    var controller = new AbortController();
    var timer = window.setTimeout(function () { controller.abort(); }, 20000);
    // Klaviyo client API/OpenAPI revision 2026-07-15. A 202 acknowledges the
    // asynchronous request; it does not prove consent, list membership or delivery.
    var request = Promise.resolve().then(function () { return window.fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(config.company), {
      method: 'POST',
      credentials: 'omit',
      referrerPolicy: 'no-referrer',
      headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', revision: '2026-07-15' },
      body: JSON.stringify(payload(email, config)),
      signal: controller.signal
    }); }).then(function (response) {
      if (response.status === 202) {
        trackAccepted(config);
        return;
      }
      if (response.status === 429) throw new Error('Too many signup requests. Wait a few minutes before trying again.');
      if (response.status === 400 || response.status === 422) throw new Error('Your request could not be accepted. Check your email address, or try again later.');
      if (response.status >= 400 && response.status < 500) throw new Error('Signup is temporarily unavailable. Please try again later.');
      throw new Error(uncertainMessage);
    }, function () {
      // An interrupted connection may have reached Klaviyo. Never retry it automatically.
      throw new Error(uncertainMessage);
    }).catch(function (error) {
      requests.delete(key);
      throw error;
    }).finally(function () {
      window.clearTimeout(timer);
    });
    requests.set(key, request);
    return request;
  }

  function bindForm(form) {
    if (forms.has(form)) return;
    var input = form.querySelector('input[name="email"]');
    var button = form.querySelector('button[type="submit"]');
    var status = form.querySelector('[data-signup-status]');
    if (!input || !button || !status) return;
    var state = {
      form: form, input: input, button: button, status: status,
      originalReadOnly: input.readOnly,
      originalLabel: button.textContent, pending: false, destroyed: false, ready: false
    };
    state.submit = function (event) {
      event.preventDefault();
      if (!state.ready || state.pending || form.dataset.signupState === 'accepted') return;
      input.value = input.value.trim();
      if (!form.reportValidity()) return;
      var config = configuration(form);
      if (!config) {
        announce(state, 'error', 'Signup is not available yet. Please check back soon.');
        return;
      }
      if (typeof window.fetch !== 'function' || typeof AbortController !== 'function') {
        announce(state, 'error', 'Signup is unavailable in this browser. Please use an updated browser.');
        return;
      }
      state.pending = true;
      announce(state, 'loading', 'Sending your request…');
      send(input.value, config).then(function () {
        announce(state, 'accepted', acceptedMessage);
      }, function (error) {
        announce(state, 'error', error.message);
      }).finally(function () { state.pending = false; });
    };
    form.addEventListener('submit', state.submit);
    forms.set(form, state);
    // The rendered input and button stay disabled until interception, browser
    // support, and the public connection are ready. This also blocks Enter-key
    // native submission if the script is delayed, blocked, or fails to start.
    if (!configuration(form)) {
      announce(state, 'error', 'Signup is not available yet. Please check back soon.');
    } else if (typeof window.fetch !== 'function' || typeof AbortController !== 'function' || typeof form.reportValidity !== 'function') {
      announce(state, 'error', 'Signup is unavailable in this browser. Please use an updated browser.');
    } else {
      state.ready = true;
      input.disabled = false;
      button.disabled = false;
      status.textContent = '';
      form.dataset.signupState = 'ready';
    }
  }

  function eachForm(root, callback) {
    if (root.matches && root.matches(selector)) callback(root);
    root.querySelectorAll(selector).forEach(callback);
  }

  function bind(root) { eachForm(root, bindForm); }

  function destroy(root) {
    eachForm(root, function (form) {
      var state = forms.get(form);
      if (!state) return;
      state.destroyed = true;
      form.removeEventListener('submit', state.submit);
      state.ready = false;
      state.button.disabled = true;
      state.input.disabled = true;
      state.button.textContent = state.originalLabel;
      state.input.readOnly = state.originalReadOnly;
      form.removeAttribute('aria-busy');
      delete form.dataset.signupState;
      forms.delete(form);
    });
  }

  window.BeefcakeZestySignup = { bind: bind, destroy: destroy };
  document.addEventListener('shopify:section:load', function (event) { bind(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { destroy(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(document); }, { once: true });
  else bind(document);
})(window, document);
